import { useReducer } from 'react';
import { useHistory } from 'react-router-dom';
import createReducer from 'helpers/reducers-helper';
import constate from 'constate';
import assign from 'lodash/assign';
import repo from 'service/repository';
import { useAppContext, UPDATE_USER_INFO } from 'use-app';
import { errorHandler } from 'helpers/error-handler';
import { PATH } from 'config';

export const CHANGE_PAYLOAD = 'change_payload';
export const CHANGE_RECEIPT_TYPE = 'CHANGE_RECEIPT_TYPE';
export const INITIALIZE = 'initialize';

const useReceipt = () => {
  const { state: appState, dispatch: appDispatch } = useAppContext();
  const history = useHistory();

  const initialize = () =>
    assign(
      {},
      {
        barcode: '',
        loveCode: '88888',
        ubn: '',
        citizenDigitalNumber: '',
        btnLoading: false,
        errorMessage: '',
      },
      appState.me
        ? {
            ...appState.me.receipt,
            barcode: appState.me.receipt.barcode ? appState.me.receipt.barcode.replace('/', '') : '',
          }
        : {}
    );
  const changPayload = (state, payload) => assign({}, state, payload);
  const changeReceiptType = (state, payload) => assign({}, state, { type: payload, errorMessage: '' });

  const updateUserReceipt = ({ type, payload }) => {
    dispatch({ type: CHANGE_PAYLOAD, payload: { btnLoading: true } });

    repo
      .updateUserInfo(undefined, undefined, { ...payload, type: type })
      .then(data => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: data,
        });
        history.push(PATH.MAIN);
      })
      .catch(error => {
        console.log(error);
        dispatch({
          type: CHANGE_PAYLOAD,
          payload: {
            btnLoading: false,
            errorMessage: errorHandler(error),
          },
        });
      });
  };

  const reducer = createReducer(
    {
      [INITIALIZE]: initialize,
      [CHANGE_PAYLOAD]: changPayload,
      [CHANGE_RECEIPT_TYPE]: changeReceiptType,
    },
    initialize,
    true
  );
  const [state, dispatch] = useReducer(reducer, initialize);

  return { state, dispatch, updateUserReceipt };
};

const [ReceiptProvider, useReceiptContext] = constate(useReceipt);

export { ReceiptProvider, useReceiptContext };
